import { render, staticRenderFns } from "./image-selector.vue?vue&type=template&id=480b8d63&scoped=true"
import script from "./image-selector.vue?vue&type=script&lang=js"
export * from "./image-selector.vue?vue&type=script&lang=js"
import style0 from "./image-selector.vue?vue&type=style&index=0&id=480b8d63&prod&scoped=true&lang=css"
import style1 from "./image-selector.vue?vue&type=style&index=1&id=480b8d63&prod&lang=css"
import style2 from "./image-selector.vue?vue&type=style&index=2&id=480b8d63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480b8d63",
  null
  
)

export default component.exports